// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const SimulationSoftwareType = {
  _3Di: "3Di",
  DFlowFm: "D-Flow FM",
} as const;
export type SimulationSoftwareType =
  (typeof SimulationSoftwareType)[keyof typeof SimulationSoftwareType];

export function instanceOfSimulationSoftwareType(value: any): boolean {
  for (const key in SimulationSoftwareType) {
    if (Object.prototype.hasOwnProperty.call(SimulationSoftwareType, key)) {
      if (SimulationSoftwareType[key as keyof typeof SimulationSoftwareType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function SimulationSoftwareTypeFromJSON(json: any): SimulationSoftwareType {
  return SimulationSoftwareTypeFromJSONTyped(json, false);
}

export function SimulationSoftwareTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulationSoftwareType {
  return json as SimulationSoftwareType;
}

export function SimulationSoftwareTypeToJSON(value?: SimulationSoftwareType | null): any {
  return value as any;
}

export function SimulationSoftwareTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): SimulationSoftwareType {
  return value as SimulationSoftwareType;
}
